import React from 'react';
import { Link as GatsByLink } from 'gatsby';
import { FormattedMessage } from 'react-intl';
import { Button } from '@printdeal/ui-library';

interface RequestQuoteProps {
  isLoggedIn: boolean,
  QUOTE_REQUEST_URL: string,
  loginPath: string
}

const RequestQuoteButton = ({
  isLoggedIn,
  QUOTE_REQUEST_URL,
  loginPath,
} : RequestQuoteProps) => (
  <div className="pd-my-5">
    <Button
      as={GatsByLink}
      to={isLoggedIn ? QUOTE_REQUEST_URL : loginPath}
      state={isLoggedIn ? null : { redirectUrl: QUOTE_REQUEST_URL }}
      data-cy="request-quote-from-sidebar"
      variant="tertiary"
    >
      <FormattedMessage id="widget.quotes.requestQuote" defaultMessage="Request quote" />
    </Button>
  </div>
);

export default RequestQuoteButton;
